import { Injectable } from '@angular/core';
import { Application } from '../models/application.model';
import { AbstractService } from './abstract_service.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService extends AbstractService {
    path = 'Application';
    reviewPath = 'Review';
}

